import { Button as MButton } from '@mui/material';
import { rcString } from '../../../utils/RemoteConfig';

import './Button.scss';

interface Props {
  id?: string;
  isLoading?: boolean;
  type?: 'button' | 'submit' | 'reset' | undefined;
  label: string;
  btnType?: 'primary' | 'secondary' | 'outline' | 'text';
  disabled?: boolean;
  onClick?: () => void;
}

const Button = ({
  isLoading,
  type,
  id,
  label,
  btnType = 'primary',
  disabled,
  onClick,
}: Props) => {
  let variant: 'text' | 'outlined' | 'contained' = 'contained';
  const generalStyle = {
    borderRadius: '10px',
    height: '60px',
    width: '100%',
    marginTop: '20px',

    fontFamily: 'Montserrat',
    fontWeight: '900',
    fontSize: '16px',
  };
  let specificStyle = {};
  switch (btnType) {
    case 'primary':
      specificStyle = {
        background: 'linear-gradient(0deg, #FC4C02, #FC4C02)', // 'linear-gradient(180deg, #FF8000 0%, #FC4C02 100%);',
      };
      break;

    case 'outline':
      variant = 'outlined';
      specificStyle = {
        background: 'transparent',
        borderColor: rcString('primary_color_plain'),
        color: rcString('primary_color_plain'),
        ':hover': { borderColor: rcString('primary_color_plain') },
      };
      break;

    case 'text':
      variant = 'text';
      specificStyle = {
        height: undefined,
        width: undefined,
        fontFamily: 'Montserrat',
        fontSize: '14px',
        fontWeight: '500',
        alignSelf: 'flex-end',
        color: rcString('primary_color_plain'),
      };
      break;

    default:
      break;
  }

  return isLoading ? (
    <div id="loading-spinner" />
  ) : (
    <MButton
      id={id || label}
      type={type}
      className={`button--${btnType}`}
      onClick={onClick}
      variant={variant}
      disabled={disabled}
      sx={{
        textTransform: 'none',
        ...generalStyle,
        ...specificStyle,
      }}>
      {label}
    </MButton>
  );
};

export default Button;
